import { t } from "i18next";
import HelpButton from "./components/pages/auth-pages/HelpButton";
import AuthHeading from "./components/pages/auth-pages/AuthHeading";
import AuthSubHeading from "./components/pages/auth-pages/AuthSubHeading";
import { useEffect } from "react";
import { Button } from "@/components/ui/Button";
import "../../styles/globals.css";
import { useSEO } from "@/contexts/SeoContext";
import { useNavigate } from "react-router-dom";
import ROUTES from "@/config/routes";

const PasswordChangeSuccess = () => {
  const { setTitle, setDescription } = useSEO();
  const navigate = useNavigate();
  
  useEffect(() => {
    setTitle("Success");
    setDescription("Password successfully changed");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="w-full h-full bg-login-bg flex items-center justify-center md:p-[40px] lg:p-[58px] bg-cover">
      <div className="w-full h-full flex flex-col">
        <div className="flex flex-row justify-end">
          <HelpButton />
        </div>
        <div className="flex h-full flex-col w-full justify-end xl:justify-center items-center">
          <div className="flex flex-col items-center justify-center gap-10">
            <div className="flex flex-col items-center justify-center gap-5">
              <AuthHeading
                text={t("v3.auth.reset_password_header", {
                  defaultValue: "Change your password 🔑",
                })}
              />
              <AuthSubHeading
                text={t("v3.auth.password_sub_header", {
                  defaultValue: "Choose a new password to login",
                })}
              />
            </div>

            <div className="flex w-full flex-col gap-2 md:mt-[30vh] xl:mt-10">
              <div className="flex gap-2 w-full justify-center items-center">
                <Button
                  className="flex flex-auto xl:flex-initial w-full text-sm bg-white text-black rounded-[10px]  xl:w-[200px] font-semibold h-[30px] hover:bg-brand-deep hover:text-white"
                  onClick={() => navigate(ROUTES.loginV3)}
                  type="button"
                >
                  {t("v3.btns.login_back", {
                    defaultValue: "Reset password",
                  })}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default PasswordChangeSuccess;
